<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-col cols="12" v-if="reservation">
                                    <v-card class="pa-0">
                                       <v-card-actions style="background-color: #f5f5f5;" class="no-print">
                                           <v-btn title="View this member's details"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="viewClientUrl"><v-icon>person</v-icon></v-btn>
                                           <v-btn title="Email the client directly"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="emailClientUrl"><v-icon>email</v-icon></v-btn>
                                           <v-btn title="Phone the client directly"
                                                  :href="phoneClientUrl"><v-icon>phone</v-icon></v-btn>
                                           <v-btn title="Log in as the client"
                                                  target="_blank"
                                                  class="d-none d-md-flex"
                                                  v-on:click="logInAsClient(reservation)"><v-icon>web</v-icon></v-btn>

                                           <v-spacer/>

                                           <v-btn title="View the property's overview page on the booking site"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="overviewUrl"><v-icon>web</v-icon></v-btn>
                                           <v-btn title="Email the property's reservations department" 
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="emailHotelUrl"><v-icon>email</v-icon></v-btn>
                                           <v-btn title="Phone the property's reservations department"
                                                  target="_blank"
                                                  :href="phoneHotelUrl"><v-icon>phone</v-icon></v-btn>

                                           <v-spacer/>

                                           <v-btn title="View the property's room types"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="roomTypesUrl"><v-icon>hotel</v-icon></v-btn>
                                           <v-btn title="View the property's rate types"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="rateTypesUrl"><v-icon>money</v-icon></v-btn>
                                           <v-btn title="View the property's ARI on its daily planner"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="plannerUrl"><v-icon>calendar_today</v-icon></v-btn>
                                           <v-btn title="View the property's special offers"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="specialOffersUrl"><v-icon>local_offer</v-icon></v-btn>

                                           <v-spacer/>
                                           <v-btn title="Change the stay dates for this reservation"
                                                  class="d-none d-md-flex"
                                                  v-on:click="setTask('changeDates')"><v-icon>edit_calendar</v-icon></v-btn>
                                           <v-btn title="Change the rooms and rates for this reservation"
                                                  class="d-none d-md-flex"
                                                  v-on:click="setTask('changeRoomsAndRates')"><v-icon>hotel</v-icon></v-btn>
                                           <v-btn title="Change the quote for this reservation"
                                                  class="d-none d-md-flex"
                                                  v-on:click="setTask('changePrices')"><v-icon>paid</v-icon></v-btn>
                                           <v-btn title="Change the status of this reservation"
                                                  class="d-none d-md-flex"
                                                  v-on:click="setTask('changeStatus')"><v-icon>crop_7_5</v-icon></v-btn>
                                           <v-btn title="Change the fees and taxes charged for this reservation"
                                                  class="d-none d-md-flex"
                                                  v-on:click="setTask('changeFees')"><v-icon>paid</v-icon></v-btn>
                                           <v-btn title="Open the reservation for direct editing"
                                                  class="d-none d-md-flex"
                                                  target="_blank"
                                                  :href="editUrl"><v-icon>edit</v-icon></v-btn>
                                            
                                           <v-btn title="Void the reservation"
                                                  class="d-none d-md-flex"
                                                  v-on:click="voidReservation(reservation)"><v-icon>delete</v-icon></v-btn>

                                           <v-btn title="Resend the messages for the current reservation status"
                                                  class="d-none d-md-flex"
                                                  v-on:click="resendNotifications(reservation)"><v-icon>email</v-icon></v-btn>
                                       </v-card-actions>

                                       <v-card-text>
                                           <!-- <v-btn v-if="!reservation.show" @click="showReservation(reservation.reservation_key)">Show Reservation</v-btn> -->
                                           <v-container fluid v-if="1 || reservation.show" class="pa-0">
                                               <v-layout row wrap>
                                                   <v-col cols="12" md="4" class="pa-0">
                                                       <ies-reservation-administration-overview :reservationkey="reservation.reservation_key"></ies-reservation-administration-overview>
                                                       <ies-reservation-administration-notes :reservationkey="reservation.reservation_key"></ies-reservation-administration-notes>
                                                   </v-col>
                                                   <v-col cols="12" 
                                                          md="8" 
                                                          v-if="task == 'changeDates'" 
                                                          class="pa-0"
                                                   >
                                                       <ies-reservation-administration-change-dates :reservationkey="reservation.reservation_key"></ies-reservation-administration-change-dates>
                                                   </v-col>

                                                    <v-col cols="12" 
                                                        md="8" 
                                                        v-if="task == 'changeRoomsAndRates'" 
                                                        class="pa-0"
                                                    >
                                                        <ies-reservation-administration-change-rooms-rates :reservationkey="reservation.reservation_key"></ies-reservation-administration-change-rooms-rates>
                                                    </v-col>

                                                    <v-col cols="12" 
                                                        md="8" 
                                                        v-if="task == 'changePrices'" 
                                                        class="pa-0"
                                                    >
                                                        <ies-reservation-administration-change-prices :reservationkey="reservation.reservation_key"></ies-reservation-administration-change-prices>
                                                    </v-col>

                                                    <v-col cols="12" 
                                                        md="8" 
                                                        v-if="task == 'changeStatus'" 
                                                        class="pa-0"
                                                    >
                                                        <ies-reservation-administration-change-status :reservationkey="reservation.reservation_key"></ies-reservation-administration-change-status>
                                                    </v-col>

                                                    <v-col cols="12" 
                                                        md="8" 
                                                        v-if="task == 'changeFees'" 
                                                        class="pa-0"
                                                    >
                                                        <ies-reservation-administration-change-fees :reservationkey="reservation.reservation_key"></ies-reservation-administration-change-fees>
                                                    </v-col>

                                                   <v-col cols="12" 
                                                          md="8" 
                                                          v-if="(reservation.status_key == 8 || reservation.status_key == 10) && task == 'manage reservation'"
                                                          class="pa-0">
                                                      <ies-reservation-administration-enquiry :reservationkey="reservation.reservation_key"></ies-reservation-administration-enquiry>
                                                   </v-col>
                                                   <v-col cols="12" md="8" v-if="reservation.status_key == 12 && task == 'manage reservation'" class="pa-0">
                                                      <ies-reservation-administration-confirmed :reservationkey="reservation.reservation_key"></ies-reservation-administration-confirmed>
                                                   </v-col>
                                                   <v-col cols="12" 
                                                          md="8" 
                                                          v-if="(reservation.status_key == 11 || reservation.status_key == 20) && task == 'manage reservation'" 
                                                          class="pa-0">
                                                      <ies-reservation-administration-awaiting :reservationkey="reservation.reservation_key"></ies-reservation-administration-awaiting>
                                                   </v-col>
                                                   <v-col cols="12" md="8" v-if="reservation.status_key == 17 && task == 'manage reservation'" class="pa-0">
                                                      <ies-reservation-administration-cancellation :reservationkey="reservation.reservation_key"></ies-reservation-administration-cancellation>
                                                   </v-col>
                                                   <v-col cols="12" md="8" v-if="reservation.status_key == 18 && task == 'manage reservation'" class="pa-0">
                                                      <ies-reservation-administration-cancelled :reservationkey="reservation.reservation_key"></ies-reservation-administration-cancelled>
                                                   </v-col>
                                                   <v-col cols="12" md="8" v-if="reservation.status_key == 15 && task == 'manage reservation'" class="pa-0">
                                                      <ies-reservation-administration-declined :reservationkey="reservation.reservation_key"></ies-reservation-administration-declined>
                                                   </v-col>
                                                   <v-col cols="12" md="8" v-if="reservation.status_key == 13 && task == 'manage reservation'" class="pa-0">
                                                       <ies-reservation-administration-accepted :reservationkey="reservation.reservation_key"></ies-reservation-administration-accepted>
                                                   </v-col>
                                                   <v-col cols="12" md="8" v-if="reservation.status_key == 9 && task == 'manage reservation'" class="pa-0">
                                                       <ies-reservation-administration-completed :reservationkey="reservation.reservation_key"></ies-reservation-administration-completed>
                                                   </v-col>


                                                   <v-col cols="12" class="pa-0">
                                                       <ies-reservation-administration-messages :reservationkey="reservation.reservation_key"></ies-reservation-administration-messages>
                                                   </v-col>

                                               </v-layout>
                                           </v-container>
                                       </v-card-text>
                                   </v-card>

            </v-col>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user manage the reservations
     * for the hotel specified, or for all hotels if not specified
     *
     * Props:
     *     int 'hotelkey' - The ID of the hotel to filter by, if any
     *     int 'reservationkey' - The ID of the reservation being managed by this component
     */
    import axios from 'axios';
    // Import the application event bus so we can listen for data changes and react accordingly
    import EventBus from '@/eventBus';
    export default {
        name: 'hotel-reservation-management',
        props: ['hotelkey', 'reservationkey'],
        data () {
            return {
                task: 'manage reservation',
                reservation: null,
                dailyPlannerUrl: this.hotelkey ? "/hotels/" + this.hotelkey + "/daily-planner" : '',
                isLoading: true,
                hasProblem: false,
                i: null
            }
        },
        methods: {

            /**
             * Register event listener that will be listening for clearSelector event to clear it's selected state
             */
            setUpEventListener() {
                EventBus.$on('Reservation Administration: Reservation changed', this.onReservationChanged);
                EventBus.$on('Reservation Administration: Task change', this.onTaskChangeRequested);
            },

            /**
             * @see data allFacilities
             */
            loadReservation(){
                try{
                    this.isLoading = true;
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;
                    this.isLoading = false;
                }.bind(this));

                } catch(exception){
                    this.hasProblem = true;
                }
            },

            /**
             * @method onReservationChanged
             * 
             * Respond to the reservation having been edited
             * by checking if the event is talking about this reservation,
             * and if so then reload it afresh so we are displaying all of
             * the correct data across the board
             * 
             * @param payload 
             */
            onReservationChanged(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.loadReservation();
                }
            },

            onTaskChangeRequested(payload){
                if (payload.reservationKey == this.reservationkey){
                   this.setTask(payload.taskName);
                }
            },


            /**
             * @method setTask
             *
             * The types of components we need to offer the user in order to manage the
             * reservation will vary depending on the task we are trying to achieve; 
             * are we trying to manage the reservation or change some part of it in some
             * way such as changing the dates
             *
             * @param string taskName
             */
            setTask(taskName){
               switch(taskName){
                   case 'changeDates':
                       this.task = 'changeDates';
                       break;
                   case 'changeRoomsAndRates':
                       this.task = 'changeRoomsAndRates';
                       break;
                   case 'changePrices':
                        this.task = 'changePrices';
                        break;
                   case 'changeStatus':
                        this.task = 'changeStatus';
                        break;
                   case 'changeFees':
                        this.task = 'changeFees';
                        break;
                   default:
                       this.task = 'manage reservation';
               }
            },


            /**
             * Trigger staff to enter the user account without authentication
             */
            logInAsClient(reservation){
                window.open("https://" + window.location.host + "/autoLogInClient?id=" + reservation.client.member_key);
            },


            dateFormatDDMMMYY(dateString){
                // Currently the dateString is being supplied in the format yyyy-mm-dd so we can
                // just rearrange the parts for the most part
                var parts = dateString.split('-');
                var monthNames = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                return parts[2] + '-' + monthNames[parseInt(parts[1])] + '-' + parts[0];
            },


            voidReservation(reservation){
                var self = this;
                if (!window.confirm("This will void the reservation.  The record will still exist, but it will not be considered a valid record and will not be displayed to the client or hotel")){
                    return;
                }

                axios.get('/api/reservation/' + reservation.reservation_key + '/set-void?action=void')
                .then(function(response){
                    alert("This reservation has now been voided and will not show to the client.\n\nPlease ensure any deposit payments are refunded and virtual cards are cancelled");
                    self.loadAllReservations();
                }.bind(this));
            },


            /**
             * Dispatches fresh copies of the email/SMS/etc notifications
             * regarding the reservation/enquir's current status in case
             * the relevant parties did not receive the original copies, or
             * the reservation has been edited directly to a new status 
             */
            resendNotifications(reservation){
                if (!window.confirm("This will send new copies of the email and SMS notifications for the reservation's current status to the client and hotelier")){
                    return;
                }

                axios.get('/api/reservation/' + reservation.reservation_key + '/send-notifications')
                .then(function(response){
                    alert("Notifications have been queued - they will be sent shortly");
                }.bind(this));
            }
        },
        /**
         * Once mounted this component needs to load all reservations for the
         * hotelkey specified
         */
        mounted() {
            try {
                // Obtain all reservations on page load
                this.loadReservation();
                this.setUpEventListener();
            } catch(exception){
                console.log(exception);
                this.hasProblem = true;
            }
        },

        computed: {
            overviewUrl: function(){ return "https://www.i-escape.com/" + this.reservation.hotel.main_url_name.url_name },
            emailClientUrl: function(){ return this.reservation && this.reservation.user ? "mailto:" + this.reservation.user.email + '?subject=i-escape.com Reservation ' + this.reservation.reference + '&body=Dear ' + this.reservation.user.first_name + ', ' : ''; },
            phoneClientUrl: function(){ return this.reservation && this.reservation.user ? "tel:" + this.reservation.user.phone_number : ''; },
            viewClientUrl: function(){ return this.reservation && this.reservation.user ? "/myescapes-members/" + this.reservation.user.member_key : ''; },
            emailHotelUrl: function(){ return this.reservation && this.reservation.hotel && this.reservation.hotel.reservation_contacts ? "mailto:" + this.reservation.hotel.reservation_contacts[0].email+'?subject=i-escape.com Reservation ' + this.reservation.reference + '&body=Dear ' + this.reservation.hotel.hotel_name + ', ' : ''; },
            phoneHotelUrl: function(){ return this.reservation && this.hotel && this.hotel.hotel_telephones ? "tel:" + this.reservation.hotel.hotel_telephones[0] : ''; },
            plannerUrl: function(){ return "/hotels/" + this.reservation.hotel.hotel_key + "/daily-planner"; }, 
            rateTypesUrl: function(){ return "/hotels/" + this.reservation.hotel.hotel_key + "/rate-types/list"; },
            roomTypesUrl: function(){ return "/hotels/" + this.reservation.hotel.hotel_key + "/room-types/list"; },
            specialOffersUrl: function(){ return "/live-hotels-offers/list?s=as&c[]=Hotel-hotel_key&o[]===&v[]=" + this.reservation.hotel.hotel_key; },
            editUrl: function(){ return "/reservations/" + this.reservation.reservation_key; }
        }
    }
</script>
<style>
     .reservation-expansion-panel {
         padding: 0;
     }

    .v-expansion-panel-content__wrap {
        padding: 0;
    }

    .expansion-panel__header {
        padding: 0;
    }

    .v-card__text {
        padding: 0 !important;
    }

    /* Highlight those records which urgently need a response from the hotelier */
    .response-overdue {
        /*background-color: #FFFABD !important; pale yellow */
        background-color: #C1CD23 !important;
    }

    .circle-icon {
        height: 25px;
        width: 25px;
        border-radius: 50%;
        display: inline-block;
    }
</style>

